import { FormlyFieldConfig } from '@ngx-formly/core';
import { InputConfiguration } from '@capturum/builders/core';

export interface FormInputConfig<T extends InputConfiguration> {
  getInput(options: T, formKey: string, defaultValue: any, defaultEmptyValue?: any): FormlyFieldConfig;
}
